export default {
  // list
  'order_cargo.column.cargoNo': 'cargoNo',
  'order_cargo.column.orderId': 'order',
  'order_cargo.column.orderType': 'orderType',
  'order_cargo.column.cargoTypeId': 'cargoType',
  'order_cargo.column.cargoTypeName': 'cargoTypeName',
  'order_cargo.column.cargoSpecId': 'cargoSpec',
  'order_cargo.column.cargoSpecName': 'cargoSpecName',
  'order_cargo.column.cargoAttrName': 'cargoAttrName',
  'order_cargo.column.cargoQty': 'cargoQty',
  'order_cargo.column.cargoWeight': 'cargoWeight',
  'order_cargo.column.loadingPoint': 'loadingPoint',
  'order_cargo.column.unloadingPoint': 'unloadingPoint',
  'order_cargo.column.cargoSource': 'cargoSource',
  'order_cargo.column.entryQty': 'entryQty',
  'order_cargo.column.entryWeight': 'entryWeight',
  'order_cargo.column.createBy': 'createBy',
  'order_cargo.column.updateBy': 'updateBy',
  'order_cargo.column.createTime': 'createTime',
  'order_cargo.column.updateTime': 'updateTime',
  'order_cargo.column.dataSource': 'dataSource',
  'order_cargo.column.remark': 'remark',
  'order_cargo.column.status': 'status',
  // edit
  'order_cargo.edit.title': 'Edit OrderCargo',
  'order_cargo.add.title': 'Add OrderCargo',
  'order_cargo.edit.success': 'Edit Successful',
  'order_cargo.add.success': 'Add Successful',
  'order_cargo.form.cargoTypeId.required': 'cargoType cannot be null',
  'order_cargo.form.cargoSpecId.required': 'cargoSpec cannot be null',
  'order_cargo.form.cargoSpecName.required': 'cargoSpecName cannot be null',
  'order_cargo.form.cargoQty.required': 'cargoQty cannot be null',
  'order_cargo.form.cargoTypeId': 'cargoTypeId',
  'order_cargo.form.cargoTypeId.placeholder': 'Enter cargoType',
  'order_cargo.form.cargoSpecId': 'cargoSpec',
  'order_cargo.form.cargoSpecId.placeholder': 'Enter cargoSpec',
  'order_cargo.form.cargoSpecName': 'cargoSpecName',
  'order_cargo.form.cargoSpecName.placeholder': 'Enter cargoSpecName',
  'order_cargo.form.cargoAttrName': 'cargoAttrName',
  'order_cargo.form.cargoAttrName.placeholder': 'Enter cargoAttrName',
  'order_cargo.form.cargoQty': 'cargoQty',
  'order_cargo.form.cargoQty.placeholder': 'Enter cargoQty',
  'order_cargo.form.loadingPoint': 'loadingPoint',
  'order_cargo.form.loadingPoint.placeholder': 'Enter loadingPoint',
  'order_cargo.form.unloadingPoint': 'unloadingPoint',
  'order_cargo.form.unloadingPoint.placeholder': 'Enter unloadingPoint',
  'order_cargo.form.remark': 'remark',
  'order_cargo.form.remark.placeholder': 'Enter remark',
}
